import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';

import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';

import { ITEMS_PER_PAGE } from '../../../constants';
import { useSearch } from '../../../hooks/use-search';

export const LazyLoader: React.FC = () => {
  const { data, fetchMore } = useSearch();
  const [nextOffset, setNextOffset] = useState(ITEMS_PER_PAGE);
  const [isLoading, setIsLoading] = useState(false);

  const totalResults = data?.jobSearchByQuery?.total ?? 0;

  const handleOnEnter = async (inView: boolean): Promise<void> => {
    if (inView && !isLoading && nextOffset < totalResults) {
      setIsLoading(true);

      await fetchMore({
        variables: {
          offset: nextOffset,
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore generated and fetchMore types are incompatible because of undefined cases
        updateQuery: (previousResult, { fetchMoreResult }) => ({
          ...previousResult,
          jobSearchByQuery: {
            ...previousResult.jobSearchByQuery,
            collection: [
              ...(previousResult.jobSearchByQuery?.collection ?? []),
              ...(fetchMoreResult?.jobSearchByQuery?.collection ?? []),
            ],
          },
        }),
      });

      setIsLoading(false);
      setNextOffset(nextOffset + ITEMS_PER_PAGE);
    }
  };

  return (
    <>
      {isLoading ? <DotLoadingIndicator /> : null}
      <InView onChange={handleOnEnter} />
    </>
  );
};
